import { z } from 'zod';

export const mineGrammarPointV1RequestSchema = z.object({
  cursor: z.coerce.number().int().min(0).optional(),
});

export type IMineGrammarPointV1Request = z.infer<typeof mineGrammarPointV1RequestSchema>;
